/**
 * Avatar colours, derived on the client.
 *
 * The API deliberately sends no avatars — a teacher screen shows children's names,
 * and there was no reason to add pictures of them to the payload. A stable pair of
 * gradient stops per person keeps the roster scannable without inventing data:
 * the same student is the same colour on every screen and in every session.
 */

/* Apple's spectrum at the depth that carries white initials: every stop below
   clears 4.5:1 against white. */
const PALETTE: Array<[string, string]> = [
  ['#0064d2', '#0071a4'],
  ['#3634a3', '#8944ab'],
  ['#c9004c', '#d70015'],
  ['#8f5b00', '#a8500c'],
  ['#217f38', '#0c7c77'],
  ['#8944ab', '#c9004c'],
  ['#0071a4', '#0064d2'],
  ['#0c7c77', '#4a7c1f'],
]

export function avatarColors(seed: string): [string, string] {
  let hash = 2166136261
  for (let i = 0; i < seed.length; i++) {
    hash ^= seed.charCodeAt(i)
    hash = Math.imul(hash, 16777619)
  }
  return PALETTE[(hash >>> 0) % PALETTE.length]
}
